import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileDevPageSide300x250Gak from './gak/MobileDevPageSide300x250';
import MobileDevPageSide300x250Fs from './freestar/MobileDevPageSide300x250';
const MobileDevPageSide300x250 = ({ safety ='off'  })=>{
    const isFreestar = useFlag('ads_freestar');
    if (isFreestar) {
        return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Fs, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Gak, {
        safety: safety
    });
};
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
